"use client";

import Link from "next/link";
import { Hero } from "./hero";
import { BentoGrid } from "./bento-grid";
import { IaEngine } from "./ia-engine";
import { TrustpilotSection } from "./trustpilot-section";

export function LandingPage() {
  return (
    <div className="min-h-dvh bg-slate-950 text-white">
      <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-slate-950/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
          <Link href="/" className="text-xl font-bold tracking-tight text-white">
            Savnally
          </Link>
          <nav className="flex items-center gap-6">
            <Link
              href="/login"
              className="text-sm font-medium text-slate-400 transition hover:text-white"
            >
              Connexion
            </Link>
            <Link
              href="/login"
              className="rounded-lg bg-gradient-to-r from-cyan-500 to-emerald-500 px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90"
            >
              Démarrer
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <Hero />
        <BentoGrid />
        <IaEngine />
        <TrustpilotSection />

        <section className="border-t border-white/10 px-4 py-16">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Prêt à transformer votre support client ?
            </h2>
            <p className="mt-4 text-slate-400">
              Rejoignez les marchands e-commerce qui utilisent Savnally pour un support omnicanal
              intelligent.
            </p>
            <div className="mt-8">
              <Link
                href="/login"
                className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-cyan-500 to-emerald-500 px-8 py-4 text-base font-semibold text-white shadow-[0_0_30px_-5px_rgba(34,211,238,0.4)] transition hover:shadow-[0_0_40px_-5px_rgba(34,211,238,0.5)]"
              >
                Accéder à la plateforme
              </Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-white/10 px-4 py-8">
        <div className="mx-auto max-w-6xl flex flex-col items-center justify-between gap-4 sm:flex-row">
          <span className="text-sm text-slate-500">© Savnally — Support client e-commerce</span>
          <div className="flex gap-6">
            <Link href="/login" className="text-sm text-slate-500 hover:text-slate-400">
              Connexion
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
